import type { ColumnDef } from "@tanstack/react-table";

import { useNavigate } from "react-router-dom";

import { DataTableCenteredCell } from "@/shared/ui/DataTable";

import { Button } from "@/shared/ui/button";
import { HandleSelectDPUserButton } from "./HeadDashboardProDataTable";
import { Roles } from "@/entities/user";
import type { Teamlead } from "@/entities/teamlead";
import { useIsCurrentlyAtDashboardPro } from "@/shared/hooks";

export const TeamleadsColumns: ColumnDef<Teamlead>[] = [
  {
    accessorKey: "username",
    header: () => (
      <DataTableCenteredCell className="text-thColor">
        Логин
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => {
      const isCurrentlyAtDashboardPro = useIsCurrentlyAtDashboardPro([
        Roles.Head,
        Roles.MasterTeamLead,
        Roles.TeamLead,
      ]);

      const navigate = useNavigate();
      const handleNavigate = () => {
        navigate(`/head/access?search=${row.original.userId.username}`);
      };

      return (
        <DataTableCenteredCell>
          {isCurrentlyAtDashboardPro ? (
            <HandleSelectDPUserButton
              userId={row.original.userId._id}
              userName={row.original.userId.username}
              userRole={Roles.TeamLead}
              // userRoleId={row.original._id}
            />
          ) : (
            <Button
              onClick={handleNavigate}
              variant="link"
              className="text-blue-500 underline"
            >
              {row.original.userId.username || "N/A"}
            </Button>
          )}
        </DataTableCenteredCell>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: () => (
      <DataTableCenteredCell className="text-thColor">
        Создан
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {new Date(row.original.createdAt).toLocaleString()}
      </DataTableCenteredCell>
    ),
  },
  {
    accessorKey: "updatedAt",
    header: () => (
      <DataTableCenteredCell className="text-thColor">
        Обновлён
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {new Date(row.original.updatedAt).toLocaleString()}
      </DataTableCenteredCell>
    ),
  },
];
